import { render, staticRenderFns } from "./triagem.vue?vue&type=template&id=6e22594a"
import script from "./triagem.vue?vue&type=script&lang=js"
export * from "./triagem.vue?vue&type=script&lang=js"
import style0 from "./triagem.vue?vue&type=style&index=0&id=6e22594a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports